import React from 'react';
import { Iconfont } from '@umu/umu-design';
import { ICON_TYPES } from './constants';

/**
 * 关闭按钮组件
 */
interface CloseButtonProps {
    onClose: () => void;
}

const CloseButton: React.FC<CloseButtonProps> = React.memo(({ onClose }) => (
    <div className="search-pdf-toolbar-icon search-pdf-toolbar-icon-close">
        <Iconfont
            type={ICON_TYPES.CLOSE}
            className="icon-close"
            onClick={onClose}
            aria-label="close search"
            role="button"
            tabIndex={0}
        />
    </div>
));

CloseButton.displayName = 'CloseButton';

export { CloseButton };
export type { CloseButtonProps };
